import { FieldsManager } from '@micromag/core';
import { defineMessage } from 'react-intl';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { v1 } from 'uuid';

var audio = {
  id: 'audio',
  component: 'audio',
  media: true
};

var audioElement = {
  id: 'audio-element',
  fields: [{
    name: 'media',
    type: 'audio'
  }],
  settings: [{
    name: 'autoPlay',
    type: 'toggle',
    label: defineMessage({
      id: "pJgYyE",
      defaultMessage: [{
        "type": 0,
        "value": "AutoPlay"
      }]
    })
  }, {
    name: 'loop',
    type: 'toggle',
    label: defineMessage({
      id: "F2SD/0",
      defaultMessage: [{
        "type": 0,
        "value": "Loop"
      }]
    })
  }, {
    name: 'withWave',
    type: 'toggle',
    label: defineMessage({
      id: "c7rrcG",
      defaultMessage: [{
        "type": 0,
        "value": "With animated wave"
      }]
    })
  }, {
    name: 'withControls',
    type: 'toggle',
    label: defineMessage({
      id: "BwYZbB",
      defaultMessage: [{
        "type": 0,
        "value": "With controls button"
      }]
    })
  }, {
    name: 'withSeekBar',
    type: 'toggle',
    label: defineMessage({
      id: "T0pi1u",
      defaultMessage: [{
        "type": 0,
        "value": "With seek bar"
      }]
    })
  }, {
    name: 'closedCaptions',
    type: 'closed-captions',
    label: defineMessage({
      id: "4H2n5r",
      defaultMessage: [{
        "type": 0,
        "value": "Closed captions"
      }]
    })
  }, {
    name: 'color',
    type: 'color',
    label: defineMessage({
      id: "Rl7C1A",
      defaultMessage: [{
        "type": 0,
        "value": "Controls color"
      }]
    })
  }, {
    name: 'progressColor',
    type: 'color',
    label: defineMessage({
      id: "v1r3AA",
      defaultMessage: [{
        "type": 0,
        "value": "Progress bar color"
      }]
    })
  }]
};

var alignHorizontal = {
  id: 'align-horizontal',
  component: 'align-horizontal'
};

var alignVertical = {
  id: 'alignVertical',
  component: 'align-vertical'
};

var answer = {
  id: 'answer',
  component: 'field-with-form',
  labelPath: 'label.body',
  fields: [{
    name: 'label',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    type: 'fields',
    isList: true,
    fields: [{
      name: 'textStyle',
      type: 'text-style-form',
      label: defineMessage({
        id: "p5RHzq",
        defaultMessage: [{
          "type": 0,
          "value": "Button text style"
        }]
      })
    }, {
      type: 'box-style-form',
      name: 'buttonStyle',
      label: defineMessage({
        id: "nno1Pq",
        defaultMessage: [{
          "type": 0,
          "value": "Button style"
        }]
      })
    }, {
      name: 'resultStyle',
      type: 'graph-bar-style',
      isList: true,
      label: defineMessage({
        id: "6Q4tcn",
        defaultMessage: [{
          "type": 0,
          "value": "Result style"
        }]
      })
    }]
  }]
};

var answers = {
  id: 'answers',
  component: 'items',
  noItemLabel: defineMessage({
    id: "A+a0kL",
    defaultMessage: [{
      "type": 0,
      "value": "No answer..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "lGh/NP",
    defaultMessage: [{
      "type": 0,
      "value": "Add an answer"
    }]
  }),
  itemsField: {
    type: 'answer',
    breadcrumbLabel: defineMessage({
      id: "XJ2Xc+",
      defaultMessage: [{
        "type": 0,
        "value": "Answer"
      }]
    })
  }
};

var authorElement = {
  id: 'author-element',
  component: 'field-with-form',
  labelPath: 'name.body',
  fields: [{
    name: 'name',
    type: 'text-element',
    label: defineMessage({
      id: "UUv8FR",
      defaultMessage: [{
        "type": 0,
        "value": "Name"
      }]
    })
  }, {
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'url',
    type: 'url',
    label: defineMessage({
      id: "ACSasN",
      defaultMessage: [{
        "type": 0,
        "value": "URL"
      }]
    })
  }, {
    name: 'collaborator',
    type: 'text-element',
    label: defineMessage({
      id: "iL9RLu",
      defaultMessage: [{
        "type": 0,
        "value": "Collaborator"
      }]
    })
  }]
};

var background = {
  id: 'background',
  isList: true,
  fields: [{
    name: 'color',
    type: 'color',
    label: defineMessage({
      id: "aarOkd",
      defaultMessage: [{
        "type": 0,
        "value": "Color"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "KuzZbb",
      defaultMessage: [{
        "type": 0,
        "value": "Background color"
      }]
    })
  }, {
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "vxEtY1",
      defaultMessage: [{
        "type": 0,
        "value": "Background image"
      }]
    })
  }, {
    name: 'video',
    type: 'video',
    label: defineMessage({
      id: "vERejo",
      defaultMessage: [{
        "type": 0,
        "value": "Video"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "dCG1T1",
      defaultMessage: [{
        "type": 0,
        "value": "Background video"
      }]
    })
  }],
  settings: [{
    type: 'fields',
    isList: true,
    fields: [{
      name: 'fit',
      type: 'fit',
      label: defineMessage({
        id: "amEvH1",
        defaultMessage: [{
          "type": 0,
          "value": "Fit"
        }]
      })
    }, {
      name: 'repeat',
      type: 'toggle',
      label: defineMessage({
        id: "WlNxMj",
        defaultMessage: [{
          "type": 0,
          "value": "Repeat"
        }]
      })
    }, {
      name: 'forceMuted',
      type: 'toggle',
      label: defineMessage({
        id: "hUUIQt",
        defaultMessage: [{
          "type": 0,
          "value": "Mute audio of background video"
        }]
      })
    }]
  }]
};

var backgroundRecommendation = {
  id: 'background-recommendation',
  isList: true,
  fields: [{
    name: 'color',
    type: 'color',
    label: defineMessage({
      id: "aarOkd",
      defaultMessage: [{
        "type": 0,
        "value": "Color"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "KuzZbb",
      defaultMessage: [{
        "type": 0,
        "value": "Background color"
      }]
    })
  }, {
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "vxEtY1",
      defaultMessage: [{
        "type": 0,
        "value": "Background image"
      }]
    })
  }, {
    name: 'video',
    type: 'video',
    label: defineMessage({
      id: "vERejo",
      defaultMessage: [{
        "type": 0,
        "value": "Video"
      }]
    }),
    breadcrumbLabel: defineMessage({
      id: "dCG1T1",
      defaultMessage: [{
        "type": 0,
        "value": "Background video"
      }]
    })
  }, {
    name: 'forceMuted',
    type: 'toggle',
    label: defineMessage({
      id: "hUUIQt",
      defaultMessage: [{
        "type": 0,
        "value": "Mute audio of background video"
      }]
    })
  }, {
    name: 'text',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "KvBdrU",
      defaultMessage: [{
        "type": 0,
        "value": "Background text"
      }]
    })
  }]
};

var badge = {
  id: 'badge',
  component: 'badge',
  fields: [{
    name: 'active',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "B5C18D",
      defaultMessage: [{
        "type": 0,
        "value": "Badge"
      }]
    })
  }, {
    name: 'label',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "6MxaVf",
      defaultMessage: [{
        "type": 0,
        "value": "Style"
      }]
    })
  }]
};

var borderRadius = {
  id: 'border-radius',
  component: 'border-radius'
};

var borderStyle = {
  id: 'border-style',
  component: 'border-style'
};

var borderWidth = {
  id: 'border-width',
  component: 'border-width'
};

var def$5 = {
  id: 'box-style',
  fields: [{
    type: 'fields',
    isList: true,
    label: defineMessage({
      id: "f5Yipd",
      defaultMessage: [{
        "type": 0,
        "value": "Box"
      }]
    }),
    fields: [{
      name: 'backgroundColor',
      label: defineMessage({
        id: "JDPMlG",
        defaultMessage: [{
          "type": 0,
          "value": "Background color"
        }]
      }),
      type: 'color'
    }, {
      name: 'borderRadius',
      type: 'number',
      isHorizontal: true,
      dataList: [0, 2, 4, 6, 8, 10, 16, 20, 24, 30],
      label: defineMessage({
        id: "xKG76H",
        defaultMessage: [{
          "type": 0,
          "value": "Rounded corners"
        }]
      })
    }, {
      name: 'padding',
      type: 'padding',
      isHorizontal: true,
      label: defineMessage({
        id: "qhjeuO",
        defaultMessage: [{
          "type": 0,
          "value": "Padding"
        }]
      })
    }]
  }, {
    type: 'fields',
    label: defineMessage({
      id: "862eE3",
      defaultMessage: [{
        "type": 0,
        "value": "Border"
      }]
    }),
    isList: true,
    fields: [{
      name: 'borderWidth',
      type: 'number',
      isHorizontal: true,
      dataList: [0, 1, 2, 3, 4, 5],
      label: defineMessage({
        id: "g2CRt5",
        defaultMessage: [{
          "type": 0,
          "value": "Size"
        }]
      })
    }, {
      name: 'borderColor',
      type: 'color',
      disableAlpha: true,
      label: defineMessage({
        id: "aarOkd",
        defaultMessage: [{
          "type": 0,
          "value": "Color"
        }]
      })
    }, {
      name: 'borderStyle',
      type: 'border-style',
      label: defineMessage({
        id: "6MxaVf",
        defaultMessage: [{
          "type": 0,
          "value": "Style"
        }]
      })
    }]
  }, {
    type: 'fields',
    label: defineMessage({
      id: "udLCuY",
      defaultMessage: [{
        "type": 0,
        "value": "Shadow"
      }]
    }),
    isList: true,
    fields: [{
      name: 'shadowDistance',
      type: 'number',
      isHorizontal: true,
      dataList: [0, 1, 2, 3, 4, 5],
      label: defineMessage({
        id: "irG6mX",
        defaultMessage: [{
          "type": 0,
          "value": "Distance"
        }]
      })
    }, {
      name: 'shadowBlur',
      type: 'number',
      isHorizontal: true,
      dataList: [0, 1, 2, 3, 4, 5],
      label: defineMessage({
        id: "TZUu3s",
        defaultMessage: [{
          "type": 0,
          "value": "Blur"
        }]
      })
    }, {
      name: 'shadowColor',
      label: defineMessage({
        id: "aarOkd",
        defaultMessage: [{
          "type": 0,
          "value": "Color"
        }]
      }),
      type: 'color'
    }, {
      name: 'shadowAngle',
      type: 'shadow-angle',
      label: defineMessage({
        id: "3LEBIA",
        defaultMessage: [{
          "type": 0,
          "value": "Angle"
        }]
      })
    }]
  }]
};

var fields$7 = def$5.fields;
var boxStyleForm = {
  id: 'box-style-form',
  component: 'box-style-form',
  fields: fields$7
};

var button = {
  id: 'button',
  component: 'field-with-form',
  labelPath: 'label',
  fields: [{
    name: 'label',
    type: 'text',
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'visual',
    type: 'visual',
    label: defineMessage({
      id: "HwqzVR",
      defaultMessage: [{
        "type": 0,
        "value": "Visual"
      }]
    })
  }, {
    name: 'textStyle',
    type: 'text-style-form',
    label: defineMessage({
      id: "rzXCu2",
      defaultMessage: [{
        "type": 0,
        "value": "Label style"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "nno1Pq",
      defaultMessage: [{
        "type": 0,
        "value": "Button style"
      }]
    })
  }, {
    name: 'url',
    type: 'url',
    label: defineMessage({
      id: "mXeSkg",
      defaultMessage: [{
        "type": 0,
        "value": "Link"
      }]
    })
  }, {
    name: 'inWebView',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "/W31TQ",
      defaultMessage: [{
        "type": 0,
        "value": "Embedded browser"
      }]
    })
  }]
};

var buttonLayout = {
  id: 'button-layout',
  component: 'button-layout'
};

var buttons = {
  id: 'buttons',
  component: 'items',
  noItemLabel: defineMessage({
    id: "CWnXWp",
    defaultMessage: [{
      "type": 0,
      "value": "No button yet"
    }]
  }),
  addItemLabel: defineMessage({
    id: "LrRW+9",
    defaultMessage: [{
      "type": 0,
      "value": "Add a button"
    }]
  }),
  itemsField: {
    type: 'button',
    breadcrumbLabel: defineMessage({
      id: "f1XHNG",
      defaultMessage: [{
        "type": 0,
        "value": "Button"
      }]
    })
  }
};

var buttonElement = {
  id: 'button-element',
  component: 'text-element',
  inline: true,
  settings: [{
    name: 'textStyle',
    type: 'text-style'
  }, {
    name: 'buttonStyle',
    type: 'box-style',
    className: 'mt-4'
  }]
};

var buttonLink = {
  id: 'button-link',
  isList: true,
  component: 'fields',
  fields: [{
    name: 'label',
    type: 'text-element',
    textOnly: true,
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'url',
    type: 'url',
    // isHorizontal: true,
    label: defineMessage({
      id: "mXeSkg",
      defaultMessage: [{
        "type": 0,
        "value": "Link"
      }]
    })
  }, {
    name: 'inWebView',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "/W31TQ",
      defaultMessage: [{
        "type": 0,
        "value": "Embedded browser"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "i6bmbD",
      defaultMessage: [{
        "type": 0,
        "value": "Button"
      }]
    })
  }]
};

var def$4 = {
  id: 'call-to-action',
  component: 'call-to-action',
  fields: [{
    name: 'active',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "eBFxNl",
      defaultMessage: [{
        "type": 0,
        "value": "Call to Action"
      }]
    })
  }, {
    name: 'type',
    type: 'radios',
    options: [{
      value: 'swipe-up',
      label: defineMessage({
        id: "OSl7A6",
        defaultMessage: [{
          "type": 0,
          "value": "Swipe up"
        }]
      })
    }, {
      value: 'button',
      label: defineMessage({
        id: "i6bmbD",
        defaultMessage: [{
          "type": 0,
          "value": "Button"
        }]
      })
    }],
    firstOptionAsDefault: true,
    isHorizontal: true,
    label: defineMessage({
      id: "iipV5Q",
      defaultMessage: [{
        "type": 0,
        "value": "Type"
      }]
    })
  }, {
    name: 'inWebView',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "/W31TQ",
      defaultMessage: [{
        "type": 0,
        "value": "Embedded browser"
      }]
    })
  }, {
    name: 'url',
    type: 'url',
    // isHorizontal: true,
    label: defineMessage({
      id: "mXeSkg",
      defaultMessage: [{
        "type": 0,
        "value": "Link"
      }]
    })
  }, {
    name: 'label',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "i6bmbD",
      defaultMessage: [{
        "type": 0,
        "value": "Button"
      }]
    })
  }]
};

var fields$6 = def$4.fields;
var callToActionForm = {
  id: 'call-to-action-form',
  component: 'call-to-action-form',
  fields: fields$6
};

var dateElement = {
  id: 'date-element',
  component: 'date-element',
  settings: [{
    name: 'textStyle',
    type: 'text-style'
  }]
};

var date = {
  id: 'date',
  component: 'date',
  withTime: false
};

var datetime = {
  id: 'datetime',
  component: 'date',
  withTime: true
};

var def$3 = {
  id: 'share-incentive',
  component: 'share-incentive',
  fields: [{
    name: 'active',
    type: 'toggle',
    isHorizontal: true,
    label: defineMessage({
      id: "uaL28k",
      defaultMessage: [{
        "type": 0,
        "value": "Share Incentive"
      }]
    })
  }, {
    name: 'label',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'boxStyle',
    type: 'box-style-form',
    label: defineMessage({
      id: "p1pghO",
      defaultMessage: [{
        "type": 0,
        "value": "Box style"
      }]
    })
  }]
};

var fields$5 = def$3.fields;
var shareIncentiveForm = {
  id: 'share-incentive-form',
  component: 'share-incentive-form',
  fields: fields$5
};

var cardLayout = {
  id: 'card-layout',
  component: 'card-layout'
};

var checkboxes = {
  id: 'checkboxes',
  component: 'checkboxes'
};

var closedCaptions = {
  id: 'closed-captions',
  component: 'closed-captions'
};

var color = {
  id: 'color',
  component: 'color'
};

var conversation = {
  id: 'conversation',
  component: 'conversation',
  fields: [{
    name: 'speakers',
    type: 'speakers',
    label: defineMessage({
      id: "JC9Qlf",
      defaultMessage: [{
        "type": 0,
        "value": "Speakers"
      }]
    })
  }, {
    name: 'messages',
    type: 'messages',
    label: defineMessage({
      id: "f68O+0",
      defaultMessage: [{
        "type": 0,
        "value": "Messages"
      }]
    })
  }],
  settings: [{
    name: 'messageStyle',
    type: 'text-style',
    label: defineMessage({
      id: "k81FRn",
      defaultMessage: [{
        "type": 0,
        "value": "Message style"
      }]
    })
  }, {
    name: 'speakerStyle',
    type: 'text-style',
    className: 'mt-4',
    label: defineMessage({
      id: "9PfjeE",
      defaultMessage: [{
        "type": 0,
        "value": "Speaker style"
      }]
    })
  }]
};

var email = {
  id: 'email',
  component: 'text',
  type: 'email'
};

var entries = {
  id: 'entries',
  component: 'items',
  noItemLabel: defineMessage({
    id: "iHV3W3",
    defaultMessage: [{
      "type": 0,
      "value": "No entry..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "l/Y6or",
    defaultMessage: [{
      "type": 0,
      "value": "Add an entry"
    }]
  }),
  itemsField: {
    type: 'entry',
    breadcrumbLabel: defineMessage({
      id: "X97njD",
      defaultMessage: [{
        "type": 0,
        "value": "Entry"
      }]
    })
  }
};

var entriesWithImage = _objectSpread(_objectSpread({}, entries), {}, {
  id: 'entries-with-image',
  itemsField: {
    type: 'entry-with-image',
    breadcrumbLabel: defineMessage({
      id: "X97njD",
      defaultMessage: [{
        "type": 0,
        "value": "Entry"
      }]
    })
  }
});

var entriesWithVisual = _objectSpread(_objectSpread({}, entries), {}, {
  id: 'entries-with-visual',
  itemsField: {
    type: 'entry-with-visual',
    breadcrumbLabel: defineMessage({
      id: "X97njD",
      defaultMessage: [{
        "type": 0,
        "value": "Entry"
      }]
    })
  }
});

var entry = {
  id: 'entry',
  component: 'field-with-form',
  labelPath: 'title.body',
  fields: [{
    name: 'title',
    type: 'heading-element',
    label: defineMessage({
      id: "+AEVbJ",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    })
  }, {
    name: 'description',
    type: 'text-element',
    label: defineMessage({
      id: "ZCe0r4",
      defaultMessage: [{
        "type": 0,
        "value": "Description"
      }]
    })
  }]
};

var entryWithImage = _objectSpread(_objectSpread({}, entry), {}, {
  id: 'entry-with-image',
  fields: [].concat(_toConsumableArray(entry.fields), [{
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }])
});

var entryWithVisual = _objectSpread(_objectSpread({}, entry), {}, {
  id: 'entry-with-visual',
  fields: [].concat(_toConsumableArray(entry.fields), [{
    name: 'image',
    type: 'visual',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }])
});

var fieldWithForm = {
  id: 'field-with-form',
  component: 'field-with-form'
};

var fields$4 = {
  id: 'fields',
  component: 'fields'
};

var fit = {
  id: 'fit',
  component: 'fit'
};

var font = {
  id: 'font',
  component: 'font',
  media: true
};

var fonts = {
  id: 'fonts',
  component: 'fonts',
  itemsField: {
    type: 'font'
  }
};

var fontFamily = {
  id: 'font-family',
  component: 'font-family'
};

var fontSize = {
  id: 'font-size',
  component: 'font-size'
};

var fontWeight = {
  id: 'font-weight',
  // component: 'font-weight',
  component: 'number-with-icon',
  icon: {
    icon: [48, 48, [], 'f067', 'M12 14h5l-7-7-7 7h5v20h-5l7 7 7-7h-5v-20zm8-4v4h24v-4h-24zm0 28h24v-4h-24v4zm0-12h24v-4h-24v4z'],
    iconName: 'font',
    prefix: 'fas'
  },
  dataList: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  "float": true
};

var footer = {
  id: 'footer',
  isList: true,
  fields: [{
    name: 'callToAction',
    type: 'call-to-action'
  }]
  // settings: [],
};

var geoPosition = {
  id: 'geo-position',
  component: 'geo-position'
};

var def$2 = {
  id: 'graph-bar-style',
  isList: true,
  fields: [{
    name: 'barColor',
    type: 'color',
    label: defineMessage({
      id: "qjL/eA",
      defaultMessage: [{
        "type": 0,
        "value": "Bar"
      }]
    })
  },
  // {
  //     name: 'textColor',
  //     type: 'color',
  //     label: defineMessage({
  //         defaultMessage: 'Text',
  //         description: 'Field label',
  //     }),
  // },
  {
    name: 'percentageTextStyle',
    type: 'text-style-form',
    label: defineMessage({
      id: "S+WiGT",
      defaultMessage: [{
        "type": 0,
        "value": "Percentage Text"
      }]
    })
  }]
};

var fields$3 = def$2.fields;
var graphBarStyleForm = {
  id: 'graph-bar-style-form',
  component: 'field-with-form',
  isList: true,
  fields: fields$3
};

var textElement = {
  id: 'text-element',
  component: 'text-element',
  settings: [{
    name: 'textStyle',
    type: 'text-style'
  }]
};

var headingElement = _objectSpread(_objectSpread({}, textElement), {}, {
  id: 'heading-element',
  size: 'lg',
  inline: true
});

var header = {
  id: 'header',
  isList: true,
  theme: true,
  fields: [{
    name: 'badge',
    type: 'badge'
  }, {
    name: 'shareIncentive',
    type: 'share-incentive'
  }]
  // settings: [],
};

var imageWithCaption = {
  id: 'image-with-caption',
  component: 'field-with-form',
  labelPath: 'caption.body',
  thumbnailPath: 'media.thumbnail_url',
  fields: [{
    name: 'media',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'caption',
    type: 'text-element',
    label: defineMessage({
      id: "p85qJD",
      defaultMessage: [{
        "type": 0,
        "value": "Caption"
      }]
    })
  }]
};

var image = {
  id: 'image',
  component: 'image',
  media: true
};

var imagesWithCaption = {
  id: 'images-with-caption',
  component: 'items',
  noItemLabel: defineMessage({
    id: "dFMzBu",
    defaultMessage: [{
      "type": 0,
      "value": "No image..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "QSmRdP",
    defaultMessage: [{
      "type": 0,
      "value": "Add an image"
    }]
  }),
  itemsField: {
    type: 'image-with-caption',
    breadcrumbLabel: defineMessage({
      id: "uwcXzb",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }
};

var images = {
  id: 'images',
  component: 'images',
  itemsField: {
    type: 'image',
    breadcrumbLabel: defineMessage({
      id: "uwcXzb",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }
};

var inputElement = {
  id: 'input-element',
  component: 'input-element',
  settings: [{
    name: 'textStyle',
    type: 'text-style'
  }, {
    name: 'buttonStyle',
    type: 'box-style',
    className: 'mt-4'
  }]
};

var items = {
  id: 'items',
  component: 'items'
};

var itemTextStyle = {
  id: 'item-text-style',
  component: 'text-style-form',
  fields: [{
    name: 'style',
    type: 'text-style'
  }]
};

var letterSpacing = {
  id: 'letter-spacing',
  component: 'number-with-icon',
  icon: {
    icon: [48, 48, [], 'f067', 'M12 14h5l-7-7-7 7h5v20h-5l7 7 7-7h-5v-20zm8-4v4h24v-4h-24zm0 28h24v-4h-24v4zm0-12h24v-4h-24v4z'],
    iconName: 'letter-spacing',
    prefix: 'fas'
  },
  iconRotation: -90,
  dataList: [-2, -1.5, -1, -0.5, 0, 0.5, 1, 1.5, 2],
  "float": true
};

var lineHeight = {
  id: 'line-height',
  component: 'number-with-icon',
  icon: {
    icon: [48, 48, [], 'f067', 'M12 14h5l-7-7-7 7h5v20h-5l7 7 7-7h-5v-20zm8-4v4h24v-4h-24zm0 28h24v-4h-24v4zm0-12h24v-4h-24v4z'],
    iconName: 'line-height',
    prefix: 'fas'
  },
  dataList: [1, 1.1, 1.2, 1.3, 1.4, 1.5, 2],
  "float": true
};

var def$1 = {
  id: 'keypad-layout',
  fields: [{
    name: 'columnAlign',
    type: 'align-horizontal',
    defaultValue: 'middle',
    label: defineMessage({
      id: "fOYYk7",
      defaultMessage: [{
        "type": 0,
        "value": "Align items"
      }]
    })
  }, {
    name: 'columns',
    type: 'radios',
    options: [{
      value: 1,
      label: 1
    }, {
      value: 2,
      label: 2
    }, {
      value: 3,
      label: 3
    }, {
      value: 4,
      label: 4
    }],
    label: defineMessage({
      id: "S1F/re",
      defaultMessage: [{
        "type": 0,
        "value": "Columns"
      }]
    })
  }, {
    name: 'spacing',
    type: 'number',
    isHorizontal: true,
    label: defineMessage({
      id: "xmp9nw",
      defaultMessage: [{
        "type": 0,
        "value": "Spacing"
      }]
    })
  }, {
    name: 'withSquareItems',
    type: 'toggle',
    label: defineMessage({
      id: "TTPc+y",
      defaultMessage: [{
        "type": 0,
        "value": "Use square keys"
      }]
    })
  }]
};

var fields$2 = def$1.fields;
var keypadLayoutForm = {
  id: 'keypad-layout-form',
  component: 'keypad-layout-form',
  fields: fields$2
};

var marker = {
  id: 'marker',
  component: 'field-with-form',
  labelPath: 'title.body',
  fields: [{
    name: 'title',
    type: 'heading-element',
    label: defineMessage({
      id: "+AEVbJ",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    })
  }, {
    name: 'description',
    type: 'text-element',
    label: defineMessage({
      id: "ZCe0r4",
      defaultMessage: [{
        "type": 0,
        "value": "Description"
      }]
    })
  }, {
    name: 'geoPosition',
    type: 'geo-position',
    label: defineMessage({
      id: "u3ok54",
      defaultMessage: [{
        "type": 0,
        "value": "Position"
      }]
    })
  }]
};

var markerWithImage = {
  id: 'marker-with-image',
  component: 'field-with-form',
  labelPath: 'title.body',
  fields: [{
    name: 'title',
    type: 'heading-element',
    label: defineMessage({
      id: "+AEVbJ",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    })
  }, {
    name: 'description',
    type: 'text-element',
    label: defineMessage({
      id: "ZCe0r4",
      defaultMessage: [{
        "type": 0,
        "value": "Description"
      }]
    })
  }, {
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'geoPosition',
    type: 'geo-position',
    label: defineMessage({
      id: "u3ok54",
      defaultMessage: [{
        "type": 0,
        "value": "Position"
      }]
    })
  }]
};

var markers = {
  id: 'markers',
  component: 'items',
  noItemLabel: defineMessage({
    id: "rdFCsN",
    defaultMessage: [{
      "type": 0,
      "value": "No marker..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "8oczXQ",
    defaultMessage: [{
      "type": 0,
      "value": "Add a marker"
    }]
  }),
  itemsField: {
    type: 'marker',
    breadcrumbLabel: defineMessage({
      id: "qroLmS",
      defaultMessage: [{
        "type": 0,
        "value": "Marker"
      }]
    })
  }
};

var markersWithImage = {
  id: 'markers-with-image',
  component: 'items',
  noItemLabel: defineMessage({
    id: "rdFCsN",
    defaultMessage: [{
      "type": 0,
      "value": "No marker..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "8oczXQ",
    defaultMessage: [{
      "type": 0,
      "value": "Add a marker"
    }]
  }),
  itemsField: {
    type: 'marker-with-image',
    breadcrumbLabel: defineMessage({
      id: "qroLmS",
      defaultMessage: [{
        "type": 0,
        "value": "Marker"
      }]
    })
  }
};

var mapZoom = {
  id: 'map-zoom',
  component: 'number',
  min: 0,
  max: 20
};

var mediaThumbnail = {
  id: 'media-thumbnail',
  component: 'media-thumbnail',
  media: true
};

var message = {
  id: 'message',
  component: 'message',
  labelPath: 'message',
  thumbnailPath: 'avatar.thumbnail_url',
  fields: [{
    name: 'speaker',
    type: 'select',
    label: defineMessage({
      id: "muPX/j",
      defaultMessage: [{
        "type": 0,
        "value": "Speaker"
      }]
    })
  }, {
    name: 'message',
    type: 'text',
    label: defineMessage({
      id: "4R/bdr",
      defaultMessage: [{
        "type": 0,
        "value": "Message"
      }]
    })
  }, {
    name: 'image',
    type: 'image',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'audio',
    type: 'audio',
    label: defineMessage({
      id: "zueWSA",
      defaultMessage: [{
        "type": 0,
        "value": "Audio attachment"
      }]
    })
  }, {
    name: 'timingOverrides',
    component: 'toggle-section',
    isList: true,
    fields: [{
      name: 'enabled',
      type: 'toggle',
      isHorizontal: true,
      label: defineMessage({
        id: "2uFkwE",
        defaultMessage: [{
          "type": 0,
          "value": "Override default timing"
        }]
      })
    }, {
      name: 'appearDelay',
      type: 'number',
      defaultValue: 2,
      label: defineMessage({
        id: "eNdbJF",
        defaultMessage: [{
          "type": 0,
          "value": "Appear delay (seconds)"
        }]
      })
    }, {
      name: 'writingDuration',
      type: 'number',
      defaultValue: 5,
      label: defineMessage({
        id: "iJ61ZT",
        defaultMessage: [{
          "type": 0,
          "value": "Writing state duration (seconds)"
        }]
      })
    }]
  }]
};

var messages = {
  id: 'messages',
  component: 'items',
  noItemLabel: defineMessage({
    id: "HTd98/",
    defaultMessage: [{
      "type": 0,
      "value": "No message..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "xCj1gI",
    defaultMessage: [{
      "type": 0,
      "value": "Add a message"
    }]
  }),
  itemsField: {
    type: 'message',
    breadcrumbLabel: defineMessage({
      id: "0GzLBc",
      defaultMessage: [{
        "type": 0,
        "value": "Message"
      }]
    })
  }
};

var metadata = {
  id: 'metadata',
  component: 'field-with-form',
  labelPath: 'title',
  noValueLabel: defineMessage({
    id: "K1BxIr",
    defaultMessage: [{
      "type": 0,
      "value": "Edit metadata..."
    }]
  }),
  fields: [{
    name: 'title',
    type: 'text',
    label: defineMessage({
      id: "+AEVbJ",
      defaultMessage: [{
        "type": 0,
        "value": "Title"
      }]
    })
  }, {
    name: 'description',
    type: 'text',
    label: defineMessage({
      id: "ZCe0r4",
      defaultMessage: [{
        "type": 0,
        "value": "Description"
      }]
    })
  }]
};

var number = {
  id: 'number',
  component: 'number'
};

var padding = {
  id: 'padding',
  component: 'padding'
};

var password = {
  id: 'password',
  component: 'text',
  type: 'password'
};

var parameters = {
  id: 'parameters',
  isList: true,
  fields: [{
    name: 'metadata',
    type: 'metadata',
    label: defineMessage({
      id: "nc8LF0",
      defaultMessage: [{
        "type": 0,
        "value": "Metadata"
      }]
    })
  }]
};

var quizAnswer = {
  id: 'quiz-answer',
  component: 'field-with-form',
  labelPath: 'label.body',
  fields: [{
    name: 'label',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'good',
    type: 'true-false',
    label: defineMessage({
      id: "I1hyZY",
      defaultMessage: [{
        "type": 0,
        "value": "Answer icon value"
      }]
    })
  }, {
    name: 'customAnswerLabel',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "Lz2+Ws",
      defaultMessage: [{
        "type": 0,
        "value": "Answer feedback"
      }]
    })
  }, {
    name: 'answerImage',
    type: 'visual',
    label: defineMessage({
      id: "57hjHa",
      defaultMessage: [{
        "type": 0,
        "value": "Answer feedback image"
      }]
    })
  }, {
    type: 'fields',
    isList: true,
    fields: [{
      name: 'textStyle',
      type: 'text-style-form',
      label: defineMessage({
        id: "p5RHzq",
        defaultMessage: [{
          "type": 0,
          "value": "Button text style"
        }]
      })
    }, {
      name: 'buttonStyle',
      type: 'box-style-form',
      label: defineMessage({
        id: "nno1Pq",
        defaultMessage: [{
          "type": 0,
          "value": "Button style"
        }]
      })
    }]
  }]
};

var quizAnswers = {
  id: 'quiz-answers',
  component: 'items',
  noItemLabel: defineMessage({
    id: "A+a0kL",
    defaultMessage: [{
      "type": 0,
      "value": "No answer..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "lGh/NP",
    defaultMessage: [{
      "type": 0,
      "value": "Add an answer"
    }]
  }),
  itemsField: {
    type: 'quiz-answer',
    breadcrumbLabel: defineMessage({
      id: "XJ2Xc+",
      defaultMessage: [{
        "type": 0,
        "value": "Answer"
      }]
    })
  }
};

var quizPointsAnswer = {
  id: 'quiz-points-answer',
  component: 'field-with-form',
  labelPath: 'label.body',
  fields: [{
    name: 'label',
    type: 'text-element',
    textOnly: true,
    fieldsProps: {
      textStyle: {
        excludedFields: ['highlight', 'link']
      }
    },
    label: defineMessage({
      id: "OJi+eg",
      defaultMessage: [{
        "type": 0,
        "value": "Label"
      }]
    })
  }, {
    name: 'points',
    type: 'number',
    isHorizontal: true,
    label: defineMessage({
      id: "jWAJW4",
      defaultMessage: [{
        "type": 0,
        "value": "Points"
      }]
    })
  }, {
    type: 'fields',
    isList: true,
    fields: [{
      type: 'box-style-form',
      name: 'buttonStyle',
      label: defineMessage({
        id: "nno1Pq",
        defaultMessage: [{
          "type": 0,
          "value": "Button style"
        }]
      })
    }]
  }]
};

var quizPointsAnswers = {
  id: 'quiz-points-answers',
  component: 'items',
  noItemLabel: defineMessage({
    id: "A+a0kL",
    defaultMessage: [{
      "type": 0,
      "value": "No answer..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "lGh/NP",
    defaultMessage: [{
      "type": 0,
      "value": "Add an answer"
    }]
  }),
  itemsField: {
    type: 'quiz-points-answer',
    breadcrumbLabel: defineMessage({
      id: "XJ2Xc+",
      defaultMessage: [{
        "type": 0,
        "value": "Answer"
      }]
    })
  }
};

var radios = {
  id: 'radios',
  component: 'radios'
};

var screenLayout = {
  id: 'screen-layout',
  component: 'screen-layout'
};

var select = {
  id: 'select',
  component: 'select-advanced'
};

var shadowAngle = {
  id: 'shadow-angle',
  component: 'shadow-angle'
};

var slider = {
  id: 'slider',
  component: 'slider'
};

var speaker = {
  id: 'speaker',
  component: 'field-with-form',
  labelPath: 'name',
  thumbnailPath: 'avatar.thumbnail_url',
  fields: [{
    name: 'name',
    type: 'text',
    label: defineMessage({
      id: "UUv8FR",
      defaultMessage: [{
        "type": 0,
        "value": "Name"
      }]
    })
  }, {
    name: 'avatar',
    type: 'image',
    label: defineMessage({
      id: "hqOIl4",
      defaultMessage: [{
        "type": 0,
        "value": "Avatar"
      }]
    })
  }, {
    name: 'side',
    type: 'radios',
    options: [{
      value: 'left',
      label: defineMessage({
        id: "O2JVA+",
        defaultMessage: [{
          "type": 0,
          "value": "Left"
        }]
      })
    }, {
      value: 'right',
      label: defineMessage({
        id: "ptJkUl",
        defaultMessage: [{
          "type": 0,
          "value": "Right"
        }]
      })
    }],
    label: defineMessage({
      id: "6ak5YN",
      defaultMessage: [{
        "type": 0,
        "value": "Side"
      }]
    })
  }, {
    name: 'color',
    type: 'color',
    label: defineMessage({
      id: "aarOkd",
      defaultMessage: [{
        "type": 0,
        "value": "Color"
      }]
    })
  }]
};

var speakers = {
  id: 'speakers',
  component: 'items',
  getDefaultValue: function getDefaultValue() {
    return {
      id: v1(),
      side: 'left'
    };
  },
  noItemLabel: defineMessage({
    id: "+nhSvj",
    defaultMessage: [{
      "type": 0,
      "value": "No speaker..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "opcGwP",
    defaultMessage: [{
      "type": 0,
      "value": "Add a speaker"
    }]
  }),
  itemsField: {
    type: 'speaker',
    breadcrumbLabel: defineMessage({
      id: "rzdds2",
      defaultMessage: [{
        "type": 0,
        "value": "Speaker"
      }]
    })
  }
};

var textModal = {
  id: 'text-modal',
  component: 'text-modal',
  media: true,
  settings: [{
    name: 'textStyle',
    type: 'text-style'
  }]
};

var def = {
  id: 'text-style',
  fields: [{
    key: 'typography',
    type: 'fields',
    label: defineMessage({
      id: "Wr9olU",
      defaultMessage: [{
        "type": 0,
        "value": "Typography"
      }]
    }),
    isList: true,
    fields: [{
      name: 'fontFamily',
      type: 'font-family',
      label: defineMessage({
        id: "ET527E",
        defaultMessage: [{
          "type": 0,
          "value": "Font family"
        }]
      })
    }, {
      name: 'color',
      type: 'color',
      label: defineMessage({
        id: "aarOkd",
        defaultMessage: [{
          "type": 0,
          "value": "Color"
        }]
      })
    }, {
      name: 'fontSize',
      type: 'font-size',
      label: defineMessage({
        id: "tYGev7",
        defaultMessage: [{
          "type": 0,
          "value": "Font size"
        }]
      })
    }, {
      component: 'font-style-with-align',
      fontStyleName: 'fontStyle',
      alignName: 'align'
    }]
  }, {
    type: 'fields',
    name: 'highlight',
    label: defineMessage({
      id: "HWpflq",
      defaultMessage: [{
        "type": 0,
        "value": "Highlight"
      }]
    }),
    isList: true,
    fields: [{
      name: 'color',
      type: 'color',
      label: defineMessage({
        id: "aarOkd",
        defaultMessage: [{
          "type": 0,
          "value": "Color"
        }]
      })
    }, {
      name: 'textColor',
      type: 'color',
      label: defineMessage({
        id: "DU1qdc",
        defaultMessage: [{
          "type": 0,
          "value": "Text color"
        }]
      })
    }]
  }, {
    type: 'fields',
    name: 'link',
    label: defineMessage({
      id: "ICXTfR",
      defaultMessage: [{
        "type": 0,
        "value": "Links"
      }]
    }),
    isList: true,
    fields: [{
      name: 'color',
      type: 'color',
      label: defineMessage({
        id: "aarOkd",
        defaultMessage: [{
          "type": 0,
          "value": "Color"
        }]
      })
    }, {
      name: 'fontStyle',
      component: 'font-style',
      isHorizontal: true,
      label: defineMessage({
        id: "6MxaVf",
        defaultMessage: [{
          "type": 0,
          "value": "Style"
        }]
      })
    }]
  }, {
    type: 'fields',
    label: defineMessage({
      id: "y7xsPe",
      defaultMessage: [{
        "type": 0,
        "value": "Advanced settings"
      }]
    }),
    isList: true,
    fields: [{
      name: 'fontWeight',
      type: 'font-weight',
      label: defineMessage({
        id: "eDMxHS",
        defaultMessage: [{
          "type": 0,
          "value": "Font weight"
        }]
      })
    }, {
      name: 'lineHeight',
      type: 'line-height',
      label: defineMessage({
        id: "31zuCS",
        defaultMessage: [{
          "type": 0,
          "value": "Line height"
        }]
      })
    }, {
      name: 'letterSpacing',
      type: 'letter-spacing',
      label: defineMessage({
        id: "Z5jrDS",
        defaultMessage: [{
          "type": 0,
          "value": "Letter spacing"
        }]
      })
    }, {
      component: 'font-style-transform',
      name: 'fontStyle',
      transformName: 'transform',
      label: defineMessage({
        id: "GMCLhn",
        defaultMessage: [{
          "type": 0,
          "value": "Case"
        }]
      })
    }]
  }]
};

var fields$1 = def.fields;
var textStyleForm = {
  id: 'text-style-form',
  component: 'text-style-form',
  fields: fields$1
};

var text = {
  id: 'text',
  component: 'text'
};

var toggle = {
  id: 'toggle',
  component: 'toggle'
};

var tokens = {
  id: 'tokens',
  component: 'tokens'
};

var trueFalse = {
  id: 'true-false',
  component: 'trueFalse'
};

var url = {
  id: 'url',
  component: 'url'
};

var video = {
  id: 'video',
  component: 'video',
  media: true
};

var videoElement = {
  id: 'video-element',
  fields: [{
    name: 'media',
    type: 'video'
  }],
  settings: [{
    name: 'autoPlay',
    type: 'toggle',
    label: defineMessage({
      id: "pJgYyE",
      defaultMessage: [{
        "type": 0,
        "value": "AutoPlay"
      }]
    })
  }, {
    name: 'loop',
    type: 'toggle',
    label: defineMessage({
      id: "F2SD/0",
      defaultMessage: [{
        "type": 0,
        "value": "Loop"
      }]
    })
  }, {
    name: 'withControls',
    type: 'toggle',
    label: defineMessage({
      id: "BwYZbB",
      defaultMessage: [{
        "type": 0,
        "value": "With controls button"
      }]
    })
  }, {
    name: 'withSeekBar',
    type: 'toggle',
    label: defineMessage({
      id: "T0pi1u",
      defaultMessage: [{
        "type": 0,
        "value": "With seek bar"
      }]
    })
  }, {
    name: 'closedCaptions',
    type: 'closed-captions',
    label: defineMessage({
      id: "4H2n5r",
      defaultMessage: [{
        "type": 0,
        "value": "Closed captions"
      }]
    })
  }, {
    name: 'thumbnail',
    type: 'media-thumbnail',
    label: defineMessage({
      id: "4kSwvn",
      defaultMessage: [{
        "type": 0,
        "value": "Thumbnail"
      }]
    })
  }, {
    name: 'color',
    type: 'color',
    label: defineMessage({
      id: "Rl7C1A",
      defaultMessage: [{
        "type": 0,
        "value": "Controls color"
      }]
    })
  }, {
    name: 'progressColor',
    type: 'color',
    label: defineMessage({
      id: "v1r3AA",
      defaultMessage: [{
        "type": 0,
        "value": "Progress bar color"
      }]
    })
  }]
};

var visual = {
  id: 'visual',
  component: 'visual',
  media: true
};

var visualWithCaption = {
  id: 'visual-with-caption',
  component: 'field-with-form',
  labelPath: 'caption.body',
  thumbnailPath: 'media.thumbnail_url',
  fields: [{
    name: 'media',
    type: 'visual',
    label: defineMessage({
      id: "xT/onn",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }, {
    name: 'caption',
    type: 'text-element',
    label: defineMessage({
      id: "p85qJD",
      defaultMessage: [{
        "type": 0,
        "value": "Caption"
      }]
    })
  }]
};

var visualsWithCaption = {
  id: 'visuals-with-caption',
  component: 'items',
  noItemLabel: defineMessage({
    id: "dFMzBu",
    defaultMessage: [{
      "type": 0,
      "value": "No image..."
    }]
  }),
  addItemLabel: defineMessage({
    id: "QSmRdP",
    defaultMessage: [{
      "type": 0,
      "value": "Add an image"
    }]
  }),
  itemsField: {
    type: 'visual-with-caption',
    breadcrumbLabel: defineMessage({
      id: "uwcXzb",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }
};

var visuals = {
  id: 'visuals',
  component: 'visuals',
  itemsField: {
    type: 'visual',
    breadcrumbLabel: defineMessage({
      id: "uwcXzb",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    })
  }
};

var fields = /*#__PURE__*/Object.freeze({
    __proto__: null,
    alignHorizontal: alignHorizontal,
    alignVertical: alignVertical,
    answer: answer,
    answers: answers,
    audio: audio,
    audioElement: audioElement,
    authorElement: authorElement,
    background: background,
    backgroundRecommendation: backgroundRecommendation,
    badge: badge,
    borderRadius: borderRadius,
    borderStyle: borderStyle,
    borderWidth: borderWidth,
    boxStyle: def$5,
    boxStyleForm: boxStyleForm,
    button: button,
    buttonElement: buttonElement,
    buttonLayout: buttonLayout,
    buttonLink: buttonLink,
    buttons: buttons,
    callToAction: def$4,
    callToActionForm: callToActionForm,
    cardLayout: cardLayout,
    checkboxes: checkboxes,
    closedCaptions: closedCaptions,
    color: color,
    conversation: conversation,
    date: date,
    dateElement: dateElement,
    datetime: datetime,
    email: email,
    entries: entries,
    entriesWithImage: entriesWithImage,
    entriesWithVisual: entriesWithVisual,
    entry: entry,
    entryWithImage: entryWithImage,
    entryWithVisual: entryWithVisual,
    fieldWithForm: fieldWithForm,
    fields: fields$4,
    fit: fit,
    font: font,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeight: fontWeight,
    fonts: fonts,
    footer: footer,
    geoPosition: geoPosition,
    graphBarStyle: def$2,
    graphBarStyleForm: graphBarStyleForm,
    header: header,
    headingElement: headingElement,
    image: image,
    imageWithCaption: imageWithCaption,
    images: images,
    imagesWithCaption: imagesWithCaption,
    inputElement: inputElement,
    itemTextStyle: itemTextStyle,
    items: items,
    keypadLayout: def$1,
    keypadLayoutForm: keypadLayoutForm,
    letterSpacing: letterSpacing,
    lineHeight: lineHeight,
    mapZoom: mapZoom,
    marker: marker,
    markerWithImage: markerWithImage,
    markers: markers,
    markersWithImage: markersWithImage,
    mediaThumbnail: mediaThumbnail,
    message: message,
    messages: messages,
    metadata: metadata,
    number: number,
    padding: padding,
    parameters: parameters,
    password: password,
    quizAnswer: quizAnswer,
    quizAnswers: quizAnswers,
    quizPOintsAnswers: quizPointsAnswers,
    quizPointsAnswer: quizPointsAnswer,
    radios: radios,
    screenLayout: screenLayout,
    select: select,
    shadowAngle: shadowAngle,
    shareIncentive: def$3,
    shareIncentiveForm: shareIncentiveForm,
    slider: slider,
    speaker: speaker,
    speakers: speakers,
    text: text,
    textElement: textElement,
    textModal: textModal,
    textStyle: def,
    textStyleForm: textStyleForm,
    toggle: toggle,
    tokens: tokens,
    trueFalse: trueFalse,
    url: url,
    video: video,
    videoElement: videoElement,
    visual: visual,
    visualWithCaption: visualWithCaption,
    visuals: visuals,
    visualsWithCaption: visualsWithCaption
});

var allFields = Object.keys(fields).map(function (name) {
  return fields[name];
});
var manager$1 = new FieldsManager(allFields);

var manager = new FieldsManager();
manager.merge(manager$1);

export { manager as default };
